import type React from 'react';

import { Button, Separator } from '@change/ds-core-ui';
import { Grid } from '@change/ds-layout';

import { Translate } from '@change-corgi/core/react/i18n';

import { useFormFooter } from './hooks/useFormFooter';

export const FormFooter: React.FC = () => {
	const { data, actions } = useFormFooter();

	return (
		<div id="form-footer-box" className="bg-background-base sticky bottom-0 z-10 w-full">
			<Separator className="m-0!" />
			<Grid className="gap-0! p-0! lg:gap-0!">
				<div className="col-span-full px-4 py-5 text-right md:px-12">
					<Button
						className="w-full md:w-40"
						variant="primary"
						disabled={data.isSubmitting}
						size="small"
						onClick={actions.handleSubmit}
						data-qa="edit-save-button"
					>
						<Translate value="corgi.petition.edit.save" />
					</Button>
				</div>
			</Grid>
		</div>
	);
};
